import { db, serverTimestamp } from "../../firebaseClient";

/**
 * 取得下一個序號並遞增 (Transaction based)
 */
export async function getNextSequence(key: string): Promise<number> {
  const counterRef = db.collection("counters").doc(key);
  
  return await db.runTransaction(async (transaction) => {
    const doc = await transaction.get(counterRef);
    if (!doc.exists) {
      transaction.set(counterRef, { current: 1, updatedAt: serverTimestamp() });
      return 1;
    }
    const newSeq = (doc.data()?.current || 0) + 1;
    transaction.update(counterRef, { current: newSeq, updatedAt: serverTimestamp() });
    return newSeq;
  });
}

/**
 * 產生標準格式單號
 */
export async function generateAutoNo(prefix: string, dateStr: string | null, padding = 3): Promise<string> {
  const key = dateStr ? `${prefix}-${dateStr}` : prefix;
  const seq = await getNextSequence(key);
  const seqStr = String(seq).padStart(padding, "0");
  return dateStr ? `${prefix}-${dateStr}-${seqStr}` : `${prefix}-${seqStr}`;
}
